import { getModifiedStats } from '@helpers/stats';
import * as Shared from '@shared/lib';
import { UserData } from '@stores';
import { create } from 'zustand';

interface GameState {
  setGameEndedState: (gameEndedState: Shared.GameEndedMessage | null) => void,
  setIsLoading: (isLoading: boolean) => void,
  gameEndedState: Shared.GameEndedMessage | null,
  playerStats: Shared.PlayerStats | null,
  weaponStats: Shared.WeaponStats | null,
  isLoading: boolean,
}

export const useGameStore = create<GameState>()(
  (set) => ({
    setGameEndedState: (gameEndedState) => set({ gameEndedState }),
    setIsLoading: (isLoading) => set({ isLoading }),
    gameEndedState: null,
    playerStats: null,
    weaponStats: null,
    isLoading: true,
  }),
);

export function updateStats(data: UserData) {
  const activeChassis = data.chassis.find(c => c.active);
  const activeWeapon = data.weapons.find(w => w.active);
  if (!activeChassis || !activeWeapon) return;

  const playerStats = getModifiedStats(data, activeChassis.id, 'chassis');
  const weaponStats = getModifiedStats(data, activeWeapon.id, 'weapon');

  useGameStore.setState({ playerStats, weaponStats });
}